import React from "react";
import { connect } from "react-redux";
import { Typography } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import SupportTab from "./SupportTab";
import SupportTabs from "./SupportTabs";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import Modal from "../Modal/Modal";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginRight: theme.spacing(2)
    }
  }
}));

const SupportModal = ({ open, onClose, info }) => {
  const [tab, setTab] = React.useState(0);
  const theme = useTheme();
  const classes = useStyles();

  const getTabs = info => {
    const tabs = [];
    const labels = [];
    if (info.customSupportDisplay === "primary") {
      tabs.push(
        <SupportTab info={info.customSupport} key="primary-custom-support" />
      );
      labels.push(info.customSupport.header);
    }
    if (info.graceHillSupportDisplay === "primary") {
      tabs.push(
        <SupportTab info={info.graceHillSupport} key="primary-gh-support" />
      );
      labels.push("Grace Hill Support");
    }
    if (info.customSupportDisplay === "secondary") {
      tabs.push(
        <SupportTab info={info.customSupport} key="secondary-custom-support" />
      );
      labels.push(info.customSupport.header);
    }
    if (info.graceHillSupportDisplay === "secondary") {
      tabs.push(
        <SupportTab info={info.graceHillSupport} key="secondary-gh-support" />
      );
      labels.push("Grace Hill Support");
    }

    return (
      <>
        <SupportTabs tab={tab} onChange={setTab} tabs={labels} />
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={tab}
        >
          {tabs}
        </SwipeableViews>
      </>
    );
  };

  return (
    <Modal
      showCloseIcon
      scrollable
      padding="none"
      maxWidth="lg"
      fullWidth
      dialogTitle={
        <Typography className={classes.title} variant="h4" color="textPrimary">
          <ContactSupportOutlinedIcon color="action" />
          Support
        </Typography>
      }
      open={open}
      onClose={onClose}
      dialogContent={getTabs(info)}
      data-qa="support-modal"
    />
  );
};

const mapStateToProps = state => ({
  info: state.supportState.supportInfo
});

export default connect(mapStateToProps)(SupportModal);
